export * from '@primeuix/themes/nora/base';
export { default } from '@primeuix/themes/nora/base';
